var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternMotionGraphics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#F39E9E",
    strokeWidth: 4,
    cx: 80,
    cy: 16,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    strokeOpacity: 0.5,
    stroke: "#F39E9E",
    strokeWidth: 4,
    cx: 48,
    cy: 16,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    strokeOpacity: 0.25,
    stroke: "#F39E9E",
    strokeWidth: 4,
    cx: 16,
    cy: 16,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF7F0",
    strokeWidth: 4,
    cx: 112,
    cy: 16,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F39E9E",
    d: "M128 64 96 32v32z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F6A560",
    x: 32,
    y: 32,
    width: 64,
    height: 32,
    rx: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 50v-4h8v4H0Zm28 0v-4h8v4h-8Zm28 0v-4h8v4h-8Z",
    fill: "#FFF7F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternMotionGraphics);
export default __webpack_public_path__ + "static/media/pattern-motion-graphics.9186d787a32a6653085008ad0de70780.svg";
export { ForwardRef as ReactComponent };